<template>
    <div>

        <div class="container">
            <div class="col-12 " style="margin-top: 10vh">
                <div class="col-12" v-if="errors.length">
                    <ul>
                        <li class="text-danger" v-for="error in errors" :key="error">{{error}}</li>
                    </ul>
                </div>
                <form action="">
                    <div class="form-group">
                        <input type="text" class="form-control text-center" placeholder="نام کاربری" v-model="username">
                    </div>
                    <div class="form-group">
                        <input type="password" class="form-control text-center" placeholder="رمز عبور"
                               v-model="password">
                    </div>
                </form>
            </div>
            <div class="col-12 mt-5 ">
                <button class="btn border-15 text-center padding hesabchi-gradient w-100 text-white" @click="login">
                    <span v-if="isLoading === false">ورود</span>
                    <!--                    <LoadingComponent v-if="isLoading"> </LoadingComponent>-->
                    <i class="fa fa-spinner" aria-hidden="true" v-if="isLoading" style="font-size: 1.5rem"></i>
                </button>
            </div>

        </div>
    </div>
</template>

<script>
    // import LoadingComponent from "../LoadingComponent";


    export default {
        name: "Login",
        components: {
            // LoadingComponent
        },
        data() {
            return {
                username: "",
                password: "",
                errors: [],
                isLoading: false,
            }
        },
        mounted() {
            this.checkToken();
        },
        methods: {
            checkToken: function () {
                let token = localStorage.getItem('token');

                if (token === null) {
                    return false;
                }

                this.axios.get(this.$hostname + "token", this.$header).then(response => {

                    if (response.data.success) {
                        this.$router.push({
                            name: "index"
                        })
                    }

                }).catch(() => {

                })
            },
            login: function () {
                this.errors = [];


                if (this.username === "") {
                    this.errors.push('نام کاربری را وارد کنید.')

                }


                if (this.password === "") {
                    this.errors.push("رمز عبور را وارد کنید.");

                }

                if (this.errors.length) {
                    return false;
                }

                let Data = {
                    username: this.username,
                    password: this.password
                };

                this.isLoading = true;

                this.axios.post(this.$hostname + "login", Data).then(response => {

                    this.isLoading = false;

                    if (!response.data.success) {
                        this.errors.push(response.data.message);
                        return false;
                    }

                    localStorage.setItem("token", response.data.data.access_token);
                    this.$token = response.data.data.access_token;

                    location.reload();

                    this.$router.push({
                        name: "index"
                    })

                }).catch(error => {
                    this.isLoading = false;
                    console.log(error.response);
                    this.errors.push('مشکلی رخ داده است');
                })
            }
        }
    }
</script>

<style scoped>

    #login-header {
        font-family: "Dast nevis", serif;

        color: #ffffff;
        font-weight: bold;
    }

    .form-control {
        border-radius: 15px;
        padding: 25px;
        font-size: 1.2rem;
    }

    .form-control:focus {
        border-color: #5fa59b;
        box-shadow: 0 0 0 0.2rem rgba(95, 165, 155, 0.7);
    }

    .form-control::placeholder {
        opacity: 0.7;
    }

    ul {
        padding-right: 0;
    }

    ul li {
        text-align: right;
    }
</style>